<div class="fui-heading-container">
  <fui-heading [text]="'com.add_edit_skill_title' | translate" [level]="5"></fui-heading>
  <button class="fui-action-btn" (click)="addSkill()">
    <fa-icon icon="plus"></fa-icon>
    {{ "com.add_edit_skills" | translate }}
  </button>
</div>

@for (type of skillsByType | keyvalue; track type) {
  <span class="bold t-18 d-block m-t-30 m-b-10">{{ "com." + (type.key == "interest" ? "interests.interests" : type.key) | translate }}</span>
  <hr />
  <div class="fui-responsive-grid">
    @for (skill of type.value; track skill) {
      <span class="t-14 p-y-10">{{ "com.skills." + skill.string_id | translate }}</span>
    }
  </div>
}
@if (loading) {
  <div class="m-y-20">
    <fa-icon icon="spinner" animation="spin"></fa-icon>
    {{ "general.loading_dots" | translate }}
  </div>
}

@if (!interests?.length && !mySkills?.length) {
  <div class="m-t-20 text-muted">{{ "com.skills.skills_description" | translate }}</div>
}
